import { notification } from 'antd';
import dayjs from 'dayjs';
import { useEffect } from 'react';

import CuriRocketSvg from '../assets/icons/CuriRocketSvg';
import { IconWrapper } from '../components/_atoms/IconWrapper';

const useFactCheckPopup = ({
  templateId,
  isAiGenerated,
  isOwner,
}: {
  templateId?: string;
  isAiGenerated: boolean;
  isOwner: boolean;
}) => {
  useEffect(() => {
    if (isOwner && isAiGenerated) {
      const expireDate = localStorage.getItem('@curipod_v1_ai_factchecker_expires_at');
      if (expireDate) {
        try {
          // if the user saw this less than 2 week ago we dont show it again
          if (dayjs(expireDate).isBefore(dayjs())) return;
        } catch {}
      }
      notification.info({
        placement: 'topRight',
        top: 70,
        message: 'Remember to fact check content generated by the AI',
        duration: 0,
        icon: (
          <IconWrapper height="50px" width="30px">
            {' '}
            <CuriRocketSvg />
          </IconWrapper>
        ),
        onClose: () => {
          localStorage.setItem(
            '@curipod_v1_ai_factchecker_expires_at',
            dayjs()
              .add(2, 'week')
              .unix()
              .toString(),
          );
        },
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [templateId, isOwner]);
};
export default useFactCheckPopup;
